import React from 'react';
import BarcodeIconSvg from './barcode.svg?react';

const BarcodeIcon = () => {
  return <BarcodeIconSvg />;
}
export default BarcodeIcon;